import { InjectionToken, Provider } from '@angular/core';

import { ApiClient } from '@packages/shared-utils';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';

export const API_CLIENT = new InjectionToken<ApiClient>('API_CLIENT');

export const apiClientProvider: Provider = {
  provide: API_CLIENT,
  useFactory: (auth: AuthService) =>
    new ApiClient(environment.apiBaseUrl, {
      baseUrl: environment.apiBaseUrl,
      tokenProvider: auth,
      refreshHeaders: { 'x-eldara-client': 'web' },
    }),
  deps: [AuthService],
};
